/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Hospitationchancenwerk2Inputs */

const de__field_hospitationchancenwerk2 = /** @type {(inputs: _Field_Hospitationchancenwerk2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hospitierende`)
};

/**

* @param {_Field_Hospitationchancenwerk2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_hospitationchancenwerk2 = /** @type {((inputs?: _Field_Hospitationchancenwerk2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Hospitationchancenwerk2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_hospitationchancenwerk2(inputs)
});
export { _field_hospitationchancenwerk2 as "_field_hospitationChancenWerk" }